<div class="rounding-sf-shell">
  <!-- Header -->
  <div class="rounding-header">
    <span class="rounding-title">Rounding to Significant Figures</span>
    <dojo-button fill="outline" size="s" (click)="randomize()">
      <dojo-icon [icon]="'shuffle'" class="mr-1.5" />
      <span>Randomize</span>
    </dojo-button>
  </div>

  <!-- Controls -->
  <div class="controls-row">
    <div class="control-group">
      <label class="control-label">Number</label>
      <input
        class="number-input"
        type="text"
        [ngModel]="inputText()"
        (ngModelChange)="onInputChange($event)"
        placeholder="e.g. 0.004076"
      />
    </div>
    <div class="control-group">
      <label class="control-label">Sig. figures</label>
      <div class="sf-stepper">
        <button class="stepper-btn" (click)="onSfChange(sf() - 1)" [disabled]="sf() <= 1">-</button>
        <span class="sf-value">{{ sf() }}</span>
        <button class="stepper-btn" (click)="onSfChange(sf() + 1)" [disabled]="sf() >= 6">+</button>
      </div>
    </div>
  </div>

  <!-- Steps -->
  <div class="steps-section">
    <!-- Step 1: Original number -->
    <div class="step">
      <div class="step-badge">1</div>
      <div class="step-content">
        <div class="step-title">Original number</div>
        <div class="digit-grid" [style.grid-template-columns]="gridTemplateColumns()">
          @for (d of breakdown().digits; track $index) {
            <span
              class="digit-char"
              [class.char-point]="d.role === 'point'"
              [class.char-leading-zero]="d.role === 'leading-zero'"
              >{{ d.char }}</span
            >
          }
        </div>
      </div>
    </div>

    <!-- Step 2: Identify & check -->
    <div class="step">
      <div class="step-badge">2</div>
      <div class="step-content">
        <div class="step-title">Identify &amp; check</div>

        <!-- Digit grid with labels -->
        <div class="digit-grid" [style.grid-template-columns]="gridTemplateColumns()">
          @for (d of breakdown().digits; track $index) {
            <div class="digit-cell-labeled">
              @if (d.role === 'keep' && d.sfIndex) {
                <span class="digit-label label-keep">{{ ordinal(d.sfIndex) }}</span>
              } @else if (d.role === 'check') {
                <span class="digit-label label-check">check</span>
              }
              <span
                class="digit-char"
                [class.char-keep]="d.role === 'keep'"
                [class.char-check]="d.role === 'check'"
                [class.char-point]="d.role === 'point'"
                [class.char-leading-zero]="d.role === 'leading-zero'"
                [class.char-discard]="d.role === 'discard'"
                >{{ d.char }}</span
              >
            </div>
          }
        </div>

        <!-- Annotations: bracket under keep digits + check logic -->
        <div class="annotation-grid" [style.grid-template-columns]="annotationGridColumns()">
          @if (keepGridColumn()) {
            <div class="bracket-label" [style.grid-column]="keepGridColumn()">{{ sf() }} s.f.</div>
          }
          @if (checkSpanColumn()) {
            <div class="check-callout" [style.grid-column]="checkSpanColumn()" [innerHTML]="checkLogicHtml()"></div>
          }
        </div>
      </div>
    </div>

    <!-- Step 3: Answer -->
    <div class="step step-last">
      <div class="step-badge">3</div>
      <div class="step-content">
        <div class="step-title">Answer</div>
        <div class="digit-grid" [style.grid-template-columns]="gridTemplateColumns()">
          @for (d of breakdown().answerDigits; track $index) {
            @if (d.char) {
              <span class="digit-char" [class.char-point]="d.isPoint" [class.char-changed]="d.changed">{{
                d.char
              }}</span>
            } @else {
              <span></span>
            }
          }
        </div>
        @if (keepGridColumn()) {
          <div
            class="annotation-grid"
            [class.annotation-grid-tight]="!breakdown().roundedUp"
            [style.grid-template-columns]="annotationGridColumns()"
          >
            <div class="bracket-label bracket-label-neutral" [style.grid-column]="keepGridColumn()">
              {{ sf() }} s.f.
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
